import React from 'react'
import logo from '../../asserts/images/logoextranet.png' ;
import signout from '../../asserts/images/exit.png' ;

import { Link } from 'react-router-dom';
function Header() {
  return (
    <div className='containerheaderextranet'>
      <div className='headerespaceextranet'>
          <div style={{maxWidth: '100%'}}><Link to="/"><img src={logo} className='logoespace' /></Link> </div>
      </div>
  
       <div className='contentdivdeconnexion'>
          <p>Déconnexion</p>
          <img src={signout} className='logout' /> 
        </div>

    </div>
  )
}

export default Header